var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavMenuArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF6F00",
    fillRule: "nonzero",
    points: "20 11 7.83 11 13.42 5.41 12 4 4 12 12 20 13.41 18.59 7.83 13 20 13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMenuArrow);
export default __webpack_public_path__ + "static/media/nav_menu_arrow.a4ee8cc9bdd912498e8538e4f2bd7989.svg";
export { ForwardRef as ReactComponent };